import { RareAlleleType } from "@app/api2/api";
import React from "react";
import { Dropdown } from "@/components/bp/bp-ui";


interface IRareAllelesFreqSelectProps {
  name: string;
  value: RareAlleleType;
  onChange?: (ev, value: RareAlleleType) => void;
  readOnly?: boolean;
}

export const RareAllelesFreqSelect: React.FunctionComponent<IRareAllelesFreqSelectProps> = (props) => {

  const rareAlleleTypes = [{ type: `${RareAlleleType.MinFreq}`, label: "BP" }, { type: `${RareAlleleType.PopN}`, label: "EFM" }, { type: `${RareAlleleType.PopLocN}`, label: "STRmix" }]

  return props.readOnly ? <>{rareAlleleTypes.find(x => x.type == `${props.value}`)?.label}</> : <Dropdown
    name={props.name}
    scrolling selection
    onChange={(ev, { value }) => {
      if (props.onChange)
        props.onChange(ev, value as RareAlleleType);
    }}
    options={[...rareAlleleTypes.map((type) => { return { key: type.type, value: type.type, text: type.label }; })]}
    value={props.value}>
  </Dropdown>
};

